import React from 'react';
import { CheckIcon } from 'lucide-react';
import { heroChecklist, heroInclusions, mockupUrl, offerAnchor, productName } from '../data/content';
import { Button } from './ui/Button';
import { Mark } from './ui/Section';
import { OfferLink } from './ui/OfferLink';
export function Hero() {
  return <section className="bg-blush-100 pb-14 md:pb-16" data-id="element-120" data-mp="4m8mecr76rkx">
      <div className="bg-plum-900 px-4 py-2.5 text-center" data-id="element-121" data-mp="4jm4pkalevoz">
        <p className="font-display text-[11px] font-extrabold uppercase tracking-[.3em] text-blush-300 md:text-xs" data-id="element-122" data-mp="128fq7kfogfw8">
          Bright Digital Hub
        </p>
      </div>
      <div className="bg-berry-600 px-4 py-2 text-center" data-id="element-123" data-mp="sb1a5lxo1t4g">
        <p className="text-[11px] font-bold uppercase tracking-wide text-white md:text-xs" data-id="element-124" data-mp="s9gh60r02i8p">
          105 Ready-to-Follow Crochet Patterns • Instant Digital Access • 7-Day Guarantee
        </p>
      </div>

      <div className="mx-auto max-w-4xl px-4 pt-8 text-center md:pt-10" data-id="element-125" data-mp="3czfl7z4xc761">
        <h1 className="mx-auto max-w-3xl text-3xl font-black uppercase leading-tight tracking-tight text-plum-950 sm:text-4xl md:text-6xl" data-id="element-126" data-mp="381nvnbrr4x50">
          Complete <span className="text-berry-600" data-id="element-127" data-mp="3o7lq5lizewmb">Crochet Bag</span> Bundle
        </h1>

        <OfferLink className="mx-auto my-7 max-w-[320px] sm:max-w-[460px]" label={`See the ${productName} offer`} data-id="element-128" data-mp="3o5j1p5xh9bjp">
          <img src={mockupUrl} alt={`${productName}: 5 complete volumes and 5 free bonus books`} className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-129" data-mp="3e9fpt8ctpyjk" />
        </OfferLink>

        <h2 className="mx-auto max-w-3xl text-xl font-black uppercase leading-snug text-plum-950 md:text-3xl" data-id="element-130" data-mp="35aklk1tcayiw">
          105 Beautiful Crochet Patterns, Ready for Your Next Project
        </h2>
        <p className="mt-4 text-base font-black uppercase text-berry-700 md:text-xl" data-id="element-131" data-mp="2vgu1d948xa90">
          5 Complete Volumes + <Mark data-id="element-132" data-mp="2hlj9m4lat58v">5 FREE Bonus Books</Mark>
        </p>
        <p className="mt-2 text-sm font-bold text-plum-900 md:text-base" data-id="element-133" data-mp="2ljpbozb6ywng">
          50 Trendy Crochet Bags + 55 Matching Accessory Projects
        </p>

        <div className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-muted md:text-base" data-id="element-134" data-mp="nbbdazp8id5t">
          <p data-id="element-135" data-mp="ic86b9pp1wv7">
            <strong className="text-plum-950" data-id="element-136" data-mp="ibyowaipsy14">Already know how to crochet?</strong> Explore 105 beautiful bag and
            accessory patterns with step-by-step instructions, yarn requirements, measurements, stitch counts, assembly
            details, and finishing guidance.
          </p>
        </div>

        <ul className="mx-auto mt-4 flex max-w-2xl flex-wrap justify-center gap-2" data-id="element-137" data-mp="161ayhbhyf83y">
          {heroInclusions.map(item => <li key={item} className="rounded-full border border-berry-600/20 bg-white px-3 py-1 text-xs font-bold text-plum-900" data-id="element-138" data-mp="111es55lsb4l8">
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-5 max-w-2xl text-sm italic text-muted md:text-base" data-id="element-139" data-mp="3lqui5yd6ip9t">
          No need to figure out how to recreate a bag from a picture.
        </p>
        <p className="mt-3 font-display text-sm font-black uppercase tracking-wide text-plum-950 md:text-base" data-id="element-140" data-mp="1xam4cnf59kxc">
          Choose your design. Gather your materials.{' '}
          <span className="text-berry-600" data-id="element-141" data-mp="269hgsh8s7r93">Follow the pattern. Start creating.</span>
        </p>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl border-2 border-dashed border-berry-500 bg-white px-5 py-8 md:px-10" data-id="element-142" data-mp="2b1984tzri10a">
          <h2 className="text-lg font-black uppercase leading-tight text-plum-950 md:text-2xl" data-id="element-143" data-mp="2fz0znmwhvl3y">
            105 Patterns. 10 Digital Books. <span className="text-berry-600" data-id="element-144" data-mp="2l0zycjhahtuk">One Complete Collection.</span>
          </h2>
          <div className="mt-6" data-id="element-145" data-mp="2oye8cdcso5nm">
            <Button href={offerAnchor} size="lg" subtext="Get Instant Digital Access Today" data-id="element-146" data-mp="2tzbnsi6f6llf">
              Yes! I want all 105 crochet patterns!
            </Button>
          </div>
          <ul className="mx-auto mt-6 grid w-fit gap-x-8 gap-y-2 text-left sm:grid-cols-2" data-id="element-147" data-mp="uou4bd2vq2d0">
            {heroChecklist.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-plum-950" data-id="element-148" data-mp="4akz14d7suim">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-berry-600" aria-hidden="true" data-id="element-149" data-mp="3vigrwid5n044" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}